import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import DetailView from "Components/DetailView";
import Summary from 'Components/Summary';
//Actions
import { changeDetailsCloseModal } from 'Redux/actions';

const ChangeDetails = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, change } = useSelector(state => state.changeDetailsRedux);

    const closeModal = () => {
        dispatch(changeDetailsCloseModal());
    }

    return (
        <Modal
            open={openModal}
            title={messages['change_details_title']}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <Summary data={change} columns={2} addDash/>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ChangeDetails;